// src/pages/CBDProducts.js
import React from 'react';
import { Container } from 'react-bootstrap';
import OverTheCounterMedication from '../components/OverTheCounterMedicartions';
const OverTheCounterMedications = () => {
  return (
    <OverTheCounterMedication/>
  );
};

export default OverTheCounterMedications;
